<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item"><a routerLink="/admin/sellerProductsList/">Products</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">New Product</li>
    </ol>
  </nav>


  <h1 class="d-block d-sm-none mb-3">Inventory</h1>

  <div class="row mt-3" *ngIf="user.role === 'ROLE_ADMIN'">
    <div class="col">
      <div class="inner-box">
        <h2>Select Customer</h2>
        <div class="row mt-4">
          <div class="col-md-4 required">
            <div class="form-group mb-1">
              <label class="control-label ">Customer</label>
              <ng-select id="accountOwner" [(ngModel)]="accountOwner"
                         [ngModelOptions]="{standalone: true}" required
                         [items]="accountOwners"
                         bindLabel="ownerName"
                         bindValue="id"
                         [searchFn]="customSearchAccountOwner"
                         (blur)="accountOwnerBlur()"
                         [ngClass]="{'is-invalid':accountOwnerError}"
                         [ngClass]="{'service-error':accountOwnerError}"
                         [searchWhileComposing]="true">
                <ng-template ng-option-tmp let-item="item">
                  {{item?.ownerName}} <br/>
                  <small>{{item?.companyName}}</small>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form>
    <div id="productSection">
      <div class="row mt-3 mr-1">
        <div class="col-md-12 mb-1 text-danger fw-500"
             *ngIf="statusText1 || statusText2 || statusText6 || statusText8 || accountOwnerError || statusText4 || statusText5 || accountOwnerError">
          Please Enter Mandatory Fields
        </div>

        <ul class="list-inline tab-list">
          <li class="list-inline-item ml-4"><a class="list-inline-item" (click)=" tabChange('basicProductInformation');"
                                               [ngClass]="{'active': tabClicked === 'basicProductInformation'}">Basic
            Product Information
            <div class="dot bg-danger ml-2" *ngIf=" statusText1 || statusText2 || statusText6 || statusText8"></div>
          </a></li>
        </ul>
        <div class="inner-box ml-3" style="width: 100%;">
          <div class="mt-4" *ngIf="tabClicked == 'basicProductInformation'">
            <div class="row">
              <div class="col-lg-9 col-md-7">
                <div class="row">
                  <div class="col-md-4 required">
                    <div class="form-group m-1 ">
                      <label class="control-label" for="product">Product Name </label>
                      <input type="text" id="product" [(ngModel)]="productName" maxlength="50" class="form-control"
                             (blur)="typeProduct()" [ngClass]="{'is-invalid':statusText1}"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <div class="col-md-4 required">
                    <div class="form-group ">
                      <label class="control-label" for="storeSku">Store SKU</label>
                      <input type="text" onkeypress='return event.charCode != 32' id="storeSku" [(ngModel)]="storeSku"
                             (blur)="typeStoreSku()" (change)="skuValue()"
                             [ngClass]="{'is-invalid':statusText2}" maxlength="12" class="form-control"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <div class="col-md-4 required">
                    <div class="form-group ">
                      <label class="control-label" for="sku">SKU</label>
                      <input type="text" id="sku" [(ngModel)]="sku" maxlength="50" class="form-control"
                             [ngModelOptions]="{standalone: true}" disabled>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label" for="length">Dimensions (L x W x H) cm</label>
                      <div class="mt-1">
                        <input type="text" id="length" [(ngModel)]="length" maxlength="50"
                               class="form-control ml-1 d-inline " style="width:105px !important"
                               [ngModelOptions]="{standalone: true}" required>
                        <input type="text" id="width" [(ngModel)]="width" maxlength="50"
                               class="form-control ml-1 d-inline " style="width:105px !important"
                               [ngModelOptions]="{standalone: true}" required>
                        <input type="text" id="height" [(ngModel)]="height" maxlength="50"
                               class="form-control ml-1 d-inline " style="width:105px !important"
                               [ngModelOptions]="{standalone: true}" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label" for="weights">Weight (Kg)</label>
                      <input type="text" id="weights" appOnlyNumbers [(ngModel)]="weight" maxlength="50"
                             class="form-control" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <div class="col-md-4 required">
                    <div class="form-group ">
                      <label class="control-label" for="hsncode">HSN Code</label>
                      <input type="text" id="hsnCode" [(ngModel)]="hsnCode" (blur)="typeHsn()"
                             [ngClass]="{'is-invalid':statusText6}" maxlength="50" class="form-control"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <!--<div class="col-md-4 required">
                    <div class="form-group ">
                      <label class="control-label" for="minQuantity">Threshold Quantity</label>
                      <input type="text" id="minQuantity" [(ngModel)]="minQuantity" maxlength="50" class="form-control"
                             onkeypress='return event.charCode >= 48 && event.charCode <= 57' (blur)="typeMinQuantity()"
                             [ngClass]="{'is-invalid':statusText8}" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>-->
                </div>
                <div class="row">

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label" for="Pricefield">Price</label>
                      <input type="text" id="Pricefield" [(ngModel)]="price" maxlength="50" class="form-control"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label" for="Taxrate">Tax Rate (%)</label>
                      <input type="text" id="Taxrate" appOnlyNumbers [(ngModel)]="taxRate" maxlength="50"
                             class="form-control" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>

                  <div class="col-md-4 required">
                    <div class="form-group mb-1">
                      <label class="control-label">Category</label>
                      <ng-select id="accountOwner" [(ngModel)]="category"
                                 [ngModelOptions]="{standalone: true}" required
                                 [items]="categories"
                                 bindLabel="categoryName"
                                 bindValue="id"
                                 (blur)="typeCategory()"
                                 [ngClass]="{'is-invalid':categoryError}"
                                 [ngClass]="{'service-error':categoryError}"
                                 [searchWhileComposing]="true">
                      </ng-select>
                      <div id="categoryError" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!categoryError">{{categoryError}}
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row">

                  <div class="col-md-4 required">
                    <div class="form-group ">
                      <label class="control-label" for="color">Color</label>
                      <input type="text" id="color" [(ngModel)]="color" (blur)="typeColor()"
                             [ngClass]="{'is-invalid':colorError}" class="form-control"
                             [ngModelOptions]="{standalone: true}" required>
                      <div id="colorError" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!colorError">{{colorError}}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 required">
                    <div class="form-group">
                      <label class="control-label" for="variant">Variant</label>
                      <input type="text" id="variant" [(ngModel)]="variant" (blur)="typeVariant()" class="form-control"
                             [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':variantError}">
                      <div id="variantError" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!variantError">{{variantError}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <!--  <label>&nbsp;</label>
                  <div class="upload-box" *ngIf="!imageUrl">
                    <input type="file" id="uploadPhoto" [(ngModel)]="imageUrl" [ngModelOptions]="{standalone: true}"
                           (change)="loadImage($event)">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    <div>Upload Image</div>
                  </div>
  -->
                <div class="upload-box mt-2">
                  <img class="shift-uploaded-img shift-image"
                       src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                       width="250" height="250"/>
                  <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}
                  </div>
                  <div class="overly">
                    <button class="btn">
                      <input type="file" id="uploadImg" [(ngModel)]="imageUrl" [ngModelOptions]="{standalone: true}"
                             (change)="loadImage($event)">
                      <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                           xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                      Upload
                    </button>
                    <button [hidden]="!imageUrl" class="btn" (change)="ignoreImage()">
                      <input type="file" id="removeImg" (change)="ignoreImage()">
                      <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                           xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                      Remove
                    </button>
                  </div>
                </div>
                <div id="imageUrlError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!imageUrlError"
                     style="position: absolute;">
                  {{imageUrlError}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-6 text-left">
      <button type="button" id="backBasicProduct" (click)="goBack()" class="btn-cancel">Back</button>
    </div>
    <div class="col-6 text-right">
      <button type="submit" id="PackingMaterialSave" (click)="submitProduct()" class="btn btn-orange ml-2">Submit
      </button>
    </div>
  </div>
</div>

<div class="modal fade style-modal" id="upLoadImage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content modal-content-shift">
      <div class="modal-body">
        <div class="form-group btn-upload">
          <label for="file" class="shift-upload-img"
                 [ngStyle]="{'background-image':'url('+ productImage +')', 'background-position': 'center', 'background-size': 'cover'}"
                 style="width:234px; height:200px"></label>
          <input type="file" class="form-control-file" (change)="loadImage($event)" id="file" accept="image/*">
        </div>
        <div class="text-right mt-3">
          <button type="button" class="btn btn-cancel" data-dismiss="modal" id="cancelI" (click)="ignoreImage()">
            Cancel
          </button>
          <button type="button" (click)="submitImage()" class="btn btn-cancel-okay ml-1 text-white" id="ok"
                  data-toggle="modal" data-dismiss="modal">Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>



